import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { SessionService } from '../../services/session.service';
import { AccountAssessment } from '../../models/AssessmentModel';
import { GridListComponent } from '../../shared/grid-list.component'

@Component({
  selector: 'cw-ci-industry-comparison-dashboard',
  templateUrl: './industry-comparison-dashboard.component.html',
  styleUrls: ['./industry-comparison-dashboard.component.scss']
})
export class IndustryComparisonDashboardComponent extends GridListComponent<Account>  implements OnInit {

  get columnsToDisplay() {
    return ['name', 'percentile'];
  }

  companyData: { name: string, percentile: number, accountAssessment: AccountAssessment }[];
  selectedCompany;

  percentiles;
  profileData = {
    industry: null,
    employees: null,
    location: null
  };

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) {
    super();
  }

  ngOnInit() {
    this.loadItems();
  }

  getItems(filter: ResultFilter): Observable<Results> {
    filter.searchData = { completed: true, showSubAccounts: true };
    return this._platformApi.getAccountAssessments(
      this._sessionService.getCurrentAccount().id,
      undefined,
      filter
    );
  }

  onAfterLoad(data) {
    this._platformApi.getPercentiles().subscribe(percs => {
      this.percentiles = percs;
      const buckets = Object.keys(this.percentiles).reverse();
      this.companyData = data.map(el => {
        const companyPerc = buckets.find(pel => el.scoredResultsJson.score >= this.percentiles[pel])
        return { name: el.accountName, percentile: +companyPerc, assessmentScore: el.scoredResultsJson.score, accountAssessment: el };
      });
    });
  }

  selectCompany(company) {
    if (this.selectedCompany == company) {
      this.selectedCompany = undefined;
      this.profileData = {
        industry: null,
        employees: null,
        location: null
      };
    } else {
      this.selectedCompany = company;
      this._platformApi.getAccountProfileData(company.accountAssessment.accountId).subscribe(data => {
        this.profileData = Object.assign(this.profileData, data);
      });
    }
  }
}
